import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

/**
 * Component to check if user is authenticated
 * Redirects to login page if not authenticated
 */
function AuthCheck({ children, requiredRoles = [] }) {
  const { isAuthenticated, hasAnyRole } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to login if not authenticated
    if (!isAuthenticated) {
      navigate("/login");
      return;
    }
    // If roles are required, ensure user has at least one
    if (requiredRoles && requiredRoles.length > 0 && !hasAnyRole(requiredRoles)) {
      // Navigate to home (or a 403 page) if lacking role
      navigate("/");
    }
  }, [isAuthenticated, hasAnyRole, requiredRoles, navigate]);

  return <>{children}</>;
}

export default AuthCheck;
